<template>
  <div class="patient-overview-hn-progress-weekly-goals">
    <v-row class="patient-overview-hn-progress-weekly-goals__header-row">
      <v-col cols="4">
      </v-col>
      <v-col cols="4" style="text-align: center;">
        <a :class="{'pull-left' : true, 'mb-10' : true, 'disabled' : !enablePrevChevron, 'patient-overview-hn-progress-weekly-goals__nextprev' : true}" @click="() => addWeeks(-1)">
          <v-icon class="patient-overview-hn-progress-weekly-goals__header-chevron">mdi-chevron-left</v-icon>
        </a>
        <span class="patient-overview-hn-progress-weekly-goals__header-dates">
          {{ startDateWeek ? startDateWeek.format('DD/MM/YYYY') : '' }} - {{ endDateWeek ? endDateWeek.format('DD/MM/YYYY') : '' }}
        </span>
        <a :class="{'pull-right' : true, 'mr-10' : true, 'disabled' : !enableNextChevron, 'patient-overview-hn-progress-weekly-goals__nextprev' : true}" @click="() => addWeeks(1)">
          <v-icon class="patient-overview-hn-progress-weekly-goals__header-chevron">mdi-chevron-right</v-icon>
        </a>
      </v-col>
      <v-col cols="4">
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <simple-table
            :headers="[
          $t('nutrition.weeklyGoals.goal'),
          $t('nutrition.weeklyGoals.reportedAmount'),
          $t('nutrition.weeklyGoals.recommendedAmount'),
          $t('nutrition.weeklyGoals.selectedAsGoal'),
      ]"
            :rows="rows"
            :table-modifier-classes="['full-width']"
        >
          <!-- custom column for goal to add icon-->
          <template v-slot:column-goal="{ rowIndex, label }">
            <food-group-icon
                :foodgroup-key="myHealthyNutritionWeek.achievedGoals[rowIndex].foodGroupKey"
                class="mr-5"
            />
            {{ label }}
          </template>
        </simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SimpleTable from "../../../components/Parts/SimpleTable.vue";
import moment from 'moment';
import FoodGroupIcon from "../../../components/Parts/HealthyNutrition/FoodGroupIcon.vue";

export default {
  name: "PatientOverviewHNProgressWeeklyGoals",
  components: {FoodGroupIcon, SimpleTable},
  props: {
    patientId: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      myHealthyNutritionWeek: {},
      selectedWeekMoment: moment(),
      loading: false,
      endOfThisWeek: moment().endOf('isoWeek')
    };
  },
  computed: {
    rows() {
      const rows = [];

      const week = this.myHealthyNutritionWeek,
          planning = week.planning,
          // show next chevron check is because we don't want to show reported values for the current week.
          showReportedValues = this.enableNextChevron && week.allAnswersGivenInWeek;

      if (week?.achievedGoals) {
        for (let key in week.achievedGoals) {
          const achievedGoal = week.achievedGoals[key], goal = achievedGoal.goal;

          let reportedAmount = null;

          if (showReportedValues) {
            reportedAmount = `${achievedGoal.answerLabel ? achievedGoal.answerLabel : ''}
             ${achievedGoal.answerLabel ? '(' + goal.foodGroup.unitLabel + ')' : ''}`;
          }

          rows.push({
            goal: goal.name,
            reportedAmount: reportedAmount,
            recommendedAmount: `${goal.foodGroup.ranges[0].label} (${goal.foodGroup.unitLabel})`,
            selectedAsGoal: planning.wasInActionStage ?
                this.$t('buttons.' + (achievedGoal.hasPatientGoals ? 'yes' : 'no'), {catalog: 'app_mobile'}) :
                this.$t('nutrition.weeklyGoals.goals.notLog2')
          })
        }
      }

      return rows;
    },
    startDateWeek() {
      return this.selectedWeekMoment ? this.selectedWeekMoment.clone().startOf('isoWeek') : null;
    },
    endDateWeek() {
      return this.selectedWeekMoment ? this.selectedWeekMoment.clone().endOf('isoWeek') : null;
    },
    enableNextChevron() {
      if (this.endDateWeek) {
        return this.endOfThisWeek.isAfter(this.endDateWeek);
      }else{
        return false;
      }
    },
    enablePrevChevron() {
      let visit1Date = this.$store.getters["patientSummary/visit1Date"];

      if (visit1Date) {
        const startOfWeekVisit1 = moment(visit1Date).startOf('isoWeek');
        const previousWeek = startOfWeekVisit1.clone().subtract(1, 'week');
        return previousWeek.isBefore(this.startDateWeek);
      }

      return false;
    }
  },
  methods: {
    async loadData() {
      this.myHealthyNutritionWeek = await this.$app.healthyNutritionManager.getHealthyNutritionWeek(
          this.patientId,
          this.selectedWeekMoment,
      )
    },
    addWeeks(weeks) {
      this.selectedWeekMoment = this.selectedWeekMoment.clone().add(weeks, 'weeks');
    }
  },
  created() {
    this.loadData();
  },
  watch: {
    patientId() {
      this.loadData();
    },
    selectedWeekMoment() {
      this.loadData();
    },
  },
}
</script>

<style>
.patient-overview-hn-progress-weekly-goals__header-row {
  font-weight: bold;
}
.patient-overview-hn-progress-weekly-goals__header-chevron.v-icon {
  font-size: 50px;
}
.patient-overview-hn-progress-weekly-goals__header-dates {
  line-height: 50px;
}
.patient-overview-hn-progress-weekly-goals__nextprev.disabled{
  opacity: 0.5;
  cursor: none;
  pointer-events: none;
}
</style>
